<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Timeline Content -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2 class="text-4xl md:text-5xl mb-10 pb-2">{{ t("Inplannen en starten") }}</h2>

            <div class="relative border-l-4 border-gray-300 pl-6 space-y-12">
              <!-- Step 1 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >1</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-lg md:text-xl font-semibold">{{ t("Beschikbaarheid bekijken") }}</h3>
                  <p>{{ t("Direct zicht op beschikbare professionals in ons overzichtelijke kalenderoverzicht.") }}</p>
                </div>
              </div>

              <!-- Step 2 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-semibold rounded-md shadow-md border-2 border-white"
                >2</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-lg md:text-xl font-semibold">{{ t("Snelle inzet") }}</h3>
                  <p>{{ t("Mogelijkheid tot spoedboekingen waarbij professionals binnen 4 uur inzetbaar zijn op locatie.") }}</p>
                </div>
              </div>

              <!-- Step 3 -->
              <div class="relative flex items-center">
                <div
                  class="absolute -left-[44px] w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-semibold rounded-md shadow-md border-2 border-white"
                >3</div>
                <div class="absolute -left-2 top-1/2 w-6 h-[2px] bg-gray-400"></div>
                <div class="ml-4">
                  <h3 class="text-lg md:text-xl font-semibold">{{ t("Digitale afhandeling") }}</h3>
                  <p>{{ t("Contractafspraken digitaal accorderen via eHerkenning en automatisch delen van inwerkmodules.") }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side: Background Image -->
          <div class="w-full h-full">
            <img
              :alt="$t('Pointing arrow to steps')"
              src="@/../img/home/calendar.png"
              class="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>